import type { Filter, Sprite } from 'pixi.js';
import { ColorMatrixFilter } from 'pixi.js';

const heartScaleDuration = 700;
const heartVariableBrightness = 0.25;
const heartMaxScaleMultiplier = 1.075;

const raysRotationDuration = 50000;

export function setHeartLoopAnimation({ bigHeart }: { bigHeart: Sprite }): void {
  const heartInitialScale = bigHeart.scale.x;
  const heartMaxScale = heartInitialScale * heartMaxScaleMultiplier;

  const filters = (Array.isArray(bigHeart.filters) ? bigHeart.filters : []) as Filter[];
  const colorMatrixFilter = filters.find((filter) => filter instanceof ColorMatrixFilter) ?? new ColorMatrixFilter();
  colorMatrixFilter.blendRequired = false;
  if (!filters.includes(colorMatrixFilter)) bigHeart.filters = [...filters, colorMatrixFilter];

  const tween = bigHeart.tweenTo(
    { scaleX: heartMaxScale, scaleY: heartMaxScale },
    heartScaleDuration,
    'sinOut',
    true,
    0,
    Infinity,
    true,
  );
  tween.onUpdate.add(() => {
    const brightness =
      1 + (1 - (heartMaxScale - bigHeart.scaleX) / (heartMaxScale - heartInitialScale)) * heartVariableBrightness;
    colorMatrixFilter.brightness(brightness, false);
  });
}

export function setRaysLoopAnimation({ rays }: { rays: Sprite }): void {
  rays.tweenTo({ angle: rays.angle + 360 }, raysRotationDuration, undefined, true, 0, Infinity);
}
